import React from "react";

import LocationSearchInput from "../../Places";

const PreLoginHead = ({ onSubmitPlace }) => (
  <div className="image-section">
    <div className="container">
      <a href="/login" className="btn btn-bordered">
        LOG IN
      </a>
      <div className="row">
        <div className="col-xs-6">
          <h4>
            Takeaway that supports <br/>
            local and earns rewards
          </h4>
        </div>

        <div className="col-xs-6">
          <div className="new-location">
            <label>Enter your address</label>
            <LocationSearchInput
              className="form-input"
              placeholder="e.g. 39 Old Town"
              onSubmit={onSubmitPlace}
            />
            <button>
              <i className="icon icon-search-gray" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PreLoginHead;
